import HeaderContainer from "./containers/HeaderContainer";
import FooterContainer from "./containers/FooterContainer";
import SummaryContainer from "./containers/SummaryContainer";
import React from "react";

const App = () => {
	return (
		<>
			<HeaderContainer title="Resumen Ventas"></HeaderContainer>
			<SummaryContainer />
			<FooterContainer />
		</>
	);
}

export default App;